<template>
  <div class="product-card-wrapper w-100">
    <v-card
      class="product-card h-100 d-flex flex-column w-100"
      elevation="0"
      @click="$router.push(`/products/${product.id}`)"
    >
      <div class="card-content">
        <v-img
          :src="product.imageUrl"
          :alt="product.name[locale]"
          height="200"
          cover
          class="product-image"
        >
          <template v-slot:placeholder>
            <v-row class="fill-height ma-0" align="center" justify="center">
              <v-progress-circular indeterminate color="primary"></v-progress-circular>
            </v-row>
          </template>
        </v-img>

        <v-card-text class="pa-4">
          <h3 class="text-h6 mb-2 text-truncate-2">{{ product.name[locale] }}</h3>
          
        </v-card-text>

        <v-card-actions class="pa-4 pt-0 mt-auto">
        <v-btn
          color="primary"
            block
          variant="elevated"
          class="contact-btn"
            @click.stop="$router.push(`/products/${product.id}`)"
        >
          <v-icon start size="small">mdi-eye</v-icon>
          {{ t('products.actions.viewDetails') }}
        </v-btn>
        </v-card-actions>
      </div>
    </v-card>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import type { Product } from '../types/product';

defineProps<{
  product: Product;
}>();

const { t, locale } = useI18n();
</script>

<style scoped>
.product-card-wrapper {
  position: relative;
  border-radius: 8px;
  border: 1px solid rgba(var(--v-theme-primary), 0.21);
  width: 100%;
  max-width: 100%;
}

.product-card-wrapper:hover {

}

.product-card {
  position: relative;
  overflow: hidden;
  transition: all 0.3s ease;
  background: white;
  height: 100%;
  width: 100%;
  border-radius: 8px !important;
}

.card-content {
  position: relative;
  background: white;
  height: 100%;
  width: 100%;
  z-index: 1;
  display: flex;
  flex-direction: column;
}

.product-image {
  border-radius: 8px 8px 0 0;
}

.text-truncate-2 {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.contact-btn {
  font-size: 13px;
  font-weight: 600;
  text-transform: none;
  height: 36px;
  transition: all 0.3s ease;
  background: linear-gradient(135deg, rgb(var(--v-theme-primary)) 0%, rgb(var(--v-theme-secondary)) 100%);
  border: none;
  border-radius: 0;
}

.contact-btn:hover {
  background: linear-gradient(135deg, rgb(var(--v-theme-secondary)) 0%, rgb(var(--v-theme-primary)) 100%);
  opacity: 0.9;
}

.v-card-text {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
}

@property --rotate {
  syntax: "<angle>";
  initial-value: 0deg;
  inherits: false;
}

@keyframes spin {
  0% {
    --rotate: 0deg;
}
  100% {
    --rotate: 360deg;
  }
}
</style> 